module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "display": "flex",
      "width": "100%",
      "margin-left": "2px"
    }
  }, [_c('div', {
    staticStyle: {
      "flex": "3.8"
    }
  }, [_c('h3', [_vm._v("订单信息")]), _vm._v(" "), _c('el-descriptions', {
    attrs: {
      "border": true,
      "column": 3
    }
  }, [_c('el-descriptions-item', {
    attrs: {
      "labelStyle": _vm.labelstyle,
      "contentStyle": _vm.contentStyle
    }
  }, [_c('template', {
    slot: "label"
  }, [_c('i', {
    staticClass: "el-icon-document",
    staticStyle: {
      "margin-right": "5px"
    }
  }), _vm._v("订单编号\n          ")]), _vm._v("\n          " + _vm._s(_vm.order.orderSn) + "\n        ")], 2), _vm._v(" "), _c('el-descriptions-item', {
    attrs: {
      "labelStyle": _vm.labelstyle,
      "contentStyle": _vm.contentStyle
    }
  }, [_c('template', {
    slot: "label"
  }, [_c('i', {
    staticClass: "el-icon-user",
    staticStyle: {
      "margin-right": "5px"
    }
  }), _vm._v("归属人\n          ")]), _vm._v("\n          " + _vm._s(_vm.order.employee.adminName) + "\n        ")], 2), _vm._v(" "), _c('el-descriptions-item', {
    attrs: {
      "labelStyle": _vm.labelstyle,
      "contentStyle": _vm.contentStyle
    }
  }, [_c('template', {
    slot: "label"
  }, [_c('i', {
    staticClass: "el-icon-time",
    staticStyle: {
      "margin-right": "5px"
    }
  }), _vm._v("订单创建时间\n          ")]), _vm._v("\n          " + _vm._s(_vm.order.createTime) + "\n        ")], 2), _vm._v(" "), _c('el-descriptions-item', {
    attrs: {
      "labelStyle": _vm.labelstyle,
      "contentStyle": _vm.contentStyle
    }
  }, [_c('template', {
    slot: "label"
  }, [_c('i', {
    staticClass: "el-icon-s-order",
    staticStyle: {
      "margin-right": "5px"
    }
  }), _vm._v("订单状态\n          ")]), _vm._v(" "), (_vm.order.orderState === 0) ? _c('el-tag', {
    attrs: {
      "type": "warning"
    }
  }, [_vm._v("待审核")]) : (_vm.order.orderState === 1) ? _c('el-tag', {
    attrs: {
      "type": "warning"
    }
  }, [_vm._v("待复审")]) : (_vm.order.orderState === 2) ? _c('el-tag', {
    attrs: {
      "type": "danger"
    }
  }, [_vm._v("审核未通过")]) : (_vm.order.orderState === 3) ? _c('el-tag', {
    attrs: {
      "type": "warning"
    }
  }, [_vm._v("待发货")]) : (_vm.order.orderState === 4) ? _c('el-tag', {
    attrs: {
      "type": "primary"
    }
  }, [_vm._v("已发货")]) : (_vm.order.orderState === 5) ? _c('el-tag', {
    attrs: {
      "type": "success"
    }
  }, [_vm._v("交易成功")]) : (_vm.order.orderState === 6) ? _c('el-tag', {
    attrs: {
      "type": "danger"
    }
  }, [_vm._v("订单取消")]) : (_vm.order.orderState === 7) ? _c('el-tag', {
    attrs: {
      "type": "warning"
    }
  }, [_vm._v("待终审")]) : _vm._e()], 2), _vm._v(" "), _c('el-descriptions-item', {
    attrs: {
      "labelStyle": _vm.labelstyle,
      "contentStyle": _vm.contentStyle
    }
  }, [_c('template', {
    slot: "label"
  }, [_c('i', {
    staticClass: "el-icon-s-custom",
    staticStyle: {
      "margin-right": "5px"
    }
  }), _vm._v("客户名称\n          ")]), _vm._v("\n          " + _vm._s(_vm.order.customer.customerName) + "\n        ")], 2), _vm._v(" "), _c('el-descriptions-item', {
    attrs: {
      "labelStyle": _vm.labelstyle,
      "contentStyle": _vm.contentStyle
    }
  }, [_c('template', {
    slot: "label"
  }, [_c('i', {
    staticClass: "el-icon-phone",
    staticStyle: {
      "margin-right": "5px"
    }
  }), _vm._v("客户手机号\n          ")]), _vm._v("\n          " + _vm._s(_vm.order.customer.phoneNumber) + "\n        ")], 2), _vm._v(" "), _c('el-descriptions-item', {
    attrs: {
      "labelStyle": _vm.labelstyle,
      "contentStyle": _vm.contentStyle
    }
  }, [_c('template', {
    slot: "label"
  }, [_c('i', {
    staticClass: "el-icon-goods",
    staticStyle: {
      "margin-right": "5px"
    }
  }), _vm._v("客户销售渠道\n          ")]), _vm._v("\n          " + _vm._s(_vm.gettypeNameById(_vm.order.customer.typeId)) + "\n        ")], 2), _vm._v(" "), _c('el-descriptions-item', {
    attrs: {
      "labelStyle": _vm.labelstyle,
      "contentStyle": _vm.contentStyle
    }
  }, [_c('template', {
    slot: "label"
  }, [_c('i', {
    staticClass: "el-icon-star-on",
    staticStyle: {
      "margin-right": "5px"
    }
  }), _vm._v("客户级别\n          ")]), _vm._v("\n          " + _vm._s(_vm.getlabelNameById(_vm.order.customer.labelId)) + "\n        ")], 2), _vm._v(" "), _c('el-descriptions-item', {
    attrs: {
      "labelStyle": _vm.labelstyle,
      "contentStyle": _vm.contentStyle
    }
  }, [_c('template', {
    slot: "label"
  }, [_c('i', {
    staticClass: "el-icon-place",
    staticStyle: {
      "margin-right": "5px"
    }
  }), _vm._v("客户来源\n          ")]), _vm._v("\n          " + _vm._s(_vm.getsourceNameById(_vm.order.customer.sourceId)) + "\n        ")], 2), _vm._v(" "), _c('el-descriptions-item', {
    attrs: {
      "labelStyle": _vm.labelstyle,
      "contentStyle": _vm.contentStyle
    }
  }, [_c('template', {
    slot: "label"
  }, [_c('i', {
    staticClass: "el-icon-money",
    staticStyle: {
      "margin-right": "5px"
    }
  }), _vm._v("订单总金额\n          ")]), _vm._v("\n          " + _vm._s(_vm.order.orderAmount) + "\n        ")], 2), _vm._v(" "), _c('el-descriptions-item', {
    attrs: {
      "labelStyle": _vm.labelstyle,
      "contentStyle": _vm.contentStyle
    }
  }, [_c('template', {
    slot: "label"
  }, [_c('i', {
    staticClass: "el-icon-wallet",
    staticStyle: {
      "margin-right": "5px"
    }
  }), _vm._v("支付方式\n          ")]), _vm._v("\n          " + _vm._s(_vm.order.payType) + "\n        ")], 2), _vm._v(" "), _c('el-descriptions-item', {
    attrs: {
      "labelStyle": _vm.labelstyle,
      "contentStyle": _vm.contentStyle
    }
  }, [_c('template', {
    slot: "label"
  }, [_c('i', {
    staticClass: "el-icon-reading",
    staticStyle: {
      "margin-right": "5px"
    }
  }), _vm._v("支付状态\n          ")]), _vm._v("\n          " + _vm._s(_vm.order.paymentStatus) + "\n        ")], 2), _vm._v(" "), _c('el-descriptions-item', {
    attrs: {
      "labelStyle": _vm.labelstyle,
      "contentStyle": _vm.contentStyle
    }
  }, [_c('template', {
    slot: "label"
  }, [_c('i', {
    staticClass: "el-icon-map-location",
    staticStyle: {
      "margin-right": "5px"
    }
  }), _vm._v("收货地址\n          ")]), _vm._v("\n          " + _vm._s(_vm.order.shippingAddress) + "\n        ")], 2), _vm._v(" "), _c('el-descriptions-item', {
    attrs: {
      "labelStyle": _vm.labelstyle,
      "contentStyle": _vm.contentStyle
    }
  }, [_c('template', {
    slot: "label"
  }, [_c('i', {
    staticClass: "el-icon-truck",
    staticStyle: {
      "margin-right": "5px"
    }
  }), _vm._v("发货方式\n          ")]), _vm._v("\n          " + _vm._s(_vm.order.logisticsMethods) + "\n        ")], 2), _vm._v(" "), _c('el-descriptions-item', {
    attrs: {
      "labelStyle": _vm.labelstyle,
      "contentStyle": _vm.contentStyle
    }
  }, [_c('template', {
    slot: "label"
  }, [_c('i', {
    staticClass: "el-icon-office-building",
    staticStyle: {
      "margin-right": "5px"
    }
  }), _vm._v("快递公司\n          ")]), _vm._v("\n          " + _vm._s(_vm.order.logisticsCompanies) + "\n        ")], 2), _vm._v(" "), _c('el-descriptions-item', {
    attrs: {
      "labelStyle": _vm.labelstyle,
      "contentStyle": _vm.contentStyle
    }
  }, [_c('template', {
    slot: "label"
  }, [_c('i', {
    staticClass: "el-icon-document",
    staticStyle: {
      "margin-right": "5px"
    }
  }), _vm._v("快递单号\n          ")]), _vm._v("\n          " + _vm._s(_vm.order.trackingNumber) + "\n        ")], 2), _vm._v(" "), _c('el-descriptions-item', {
    attrs: {
      "labelStyle": _vm.labelstyle,
      "contentStyle": _vm.contentStyle
    }
  }, [_c('template', {
    slot: "label"
  }, [_c('i', {
    staticClass: "el-icon-edit",
    staticStyle: {
      "margin-right": "5px"
    }
  }), _vm._v("订单备注\n          ")]), _vm._v("\n          " + _vm._s(_vm.order.notes) + "\n        ")], 2), _vm._v(" "), _c('el-descriptions-item', {
    attrs: {
      "labelStyle": _vm.labelstyle,
      "contentStyle": _vm.contentStyle
    }
  }, [_c('template', {
    slot: "label"
  }, [_c('i', {
    staticClass: "el-icon-edit",
    staticStyle: {
      "margin-right": "5px"
    }
  }), _vm._v("物流备注\n          ")]), _vm._v("\n          " + _vm._s(_vm.order.remarks) + "\n        ")], 2), _vm._v(" "), _c('el-descriptions-item', {
    attrs: {
      "labelStyle": _vm.labelstyle,
      "contentStyle": _vm.contentStyle
    }
  }, [_c('template', {
    slot: "label"
  }, [_c('i', {
    staticClass: "el-icon-picture",
    staticStyle: {
      "margin-right": "5px"
    }
  }), _vm._v("收款凭证\n          ")]), _vm._v(" "), (_vm.order.receipt && _vm.order.receipt.length > 0) ? _c('div', {
    staticClass: "image-container"
  }, _vm._l((_vm.order.receipt), function(image, imgIndex) {
    return _c('el-image', {
      key: imgIndex,
      staticClass: "image-container-box",
      attrs: {
        "src": image,
        "preview-src-list": _vm.order.receipt,
        "fit": "contain"
      }
    })
  }), 1) : _c('div', {
    staticClass: "no-images-message"
  }, [_vm._v("\n            暂时没有图片\n          ")])], 2)], 1), _vm._v(" "), _c('h3', [_vm._v("订单还款")]), _vm._v(" "), _c('el-form', {
    ref: "orderForm",
    staticClass: "border",
    attrs: {
      "model": _vm.orderForm,
      "label-width": "90px",
      "rules": _vm.rules,
      "label-position": "right"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "支付状态:",
      "prop": "paymentStatus"
    }
  }, [_c('el-radio-group', {
    attrs: {
      "placeholder": "请选择订单支付状态"
    },
    model: {
      value: (_vm.orderForm.paymentStatus),
      callback: function($$v) {
        _vm.$set(_vm.orderForm, "paymentStatus", $$v)
      },
      expression: "orderForm.paymentStatus"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "欠款",
      "border": "",
      "size": "medium"
    }
  }, [_c('i', {
    staticClass: "el-icon-warning icon-overdue"
  }), _vm._v(" 欠款\n            ")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "部分还款",
      "border": "",
      "size": "medium"
    }
  }, [_c('i', {
    staticClass: "el-icon-warning-outline icon-partially-overdue"
  }), _vm._v(" 部分还款\n            ")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "还款完成",
      "border": "",
      "size": "medium"
    }
  }, [_c('i', {
    staticClass: "el-icon-check icon-paid"
  }), _vm._v(" 还款完成\n            ")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "还款方式:",
      "prop": "repaymentMethod"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "placeholder": "请输入还款方式"
    },
    model: {
      value: (_vm.orderForm.repaymentMethod),
      callback: function($$v) {
        _vm.$set(_vm.orderForm, "repaymentMethod", $$v)
      },
      expression: "orderForm.repaymentMethod"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "还款金额:",
      "prop": "paymentAmount"
    }
  }, [_c('el-input-number', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "precision": 2,
      "step": 0.1,
      "min": 0.00,
      "placeholder": "请输入还款金额"
    },
    model: {
      value: (_vm.orderForm.paymentAmount),
      callback: function($$v) {
        _vm.$set(_vm.orderForm, "paymentAmount", $$v)
      },
      expression: "orderForm.paymentAmount"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "收款凭证:",
      "prop": "receipt"
    }
  }, [_c('el-row', {
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "gutter": 20
    }
  }, _vm._l((_vm.order.receipt), function(url, index) {
    return _c('el-col', {
      key: index,
      attrs: {
        "span": 6
      }
    }, [_c('el-image', {
      staticStyle: {
        "width": "100%",
        "height": "100px"
      },
      attrs: {
        "src": url,
        "preview-src-list": _vm.order.receipt,
        "z-index": 2000
      }
    })], 1)
  }), 1), _vm._v(" "), _c('el-upload', {
    staticClass: "upload-demo",
    attrs: {
      "name": "file",
      "action": this.$uploadURL,
      "on-remove": _vm.handleFileRemove,
      "on-success": _vm.handleFileUpload,
      "on-exceed": _vm.handleFileExceed,
      "multiple": true,
      "limit": 5,
      "file-list": _vm.fileList,
      "accept": ".jpg,.png,.gif",
      "list-type": "picture"
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    }
  }, [_vm._v("新增凭证")])], 1)], 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.uptoorder
    }
  }, [_vm._v("确认还款")])], 1), _vm._v(" "), _c('h3', [_vm._v("订单产品信息")]), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.productList,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "productName",
      "label": "产品名称",
      "align": 'center'
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "picture",
      "label": "产品图片",
      "align": 'center'
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('img', {
          staticStyle: {
            "width": "100px",
            "height": "100px"
          },
          attrs: {
            "src": scope.row.picture,
            "preview-src-list": [scope.row.picture],
            "alt": "Product Image"
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "price",
      "label": "产品价格",
      "align": 'center'
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "costPrice",
      "label": "售价",
      "align": 'center'
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "orderNum",
      "label": "选购数量",
      "align": 'center'
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "salePrice",
      "label": "成交价",
      "align": 'center'
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "orderAmount",
      "label": "金额",
      "align": 'center'
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "flex": "1.2",
      "display": "flex",
      "flex-direction": "column"
    }
  }, [_c('div', [_c('h5', [_vm._v("订单信息")]), _vm._v(" "), _c('el-timeline', {
    attrs: {
      "reverse": _vm.reverse
    }
  }, _vm._l((_vm.orderTimeList), function(item, index) {
    return _c('el-timeline-item', {
      key: index,
      attrs: {
        "color": _vm.getColor(item, index)
      }
    }, [_c('div', {
      style: (index === 0 ? {
        color: '#5EA8F8'
      } : {})
    }, [_c('span', [_vm._v(_vm._s(item.time))]), _vm._v(" "), _c('el-tag', {
      staticStyle: {
        "margin-left": "10px"
      },
      attrs: {
        "type": _vm.getTagType(item, index)
      }
    }, [_vm._v("\n                " + _vm._s(item.operateType) + "\n              ")])], 1), _vm._v(" "), _c('div', {
      staticStyle: {
        "margin-top": "8px",
        "margin-bottom": "20px",
        "font-size": "13px",
        "color": "gray"
      }
    }, [_vm._v("\n              " + _vm._s(item.content) + "\n            ")])])
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "flex": "1"
    }
  }, [_c('h5', [_vm._v("还款信息")]), _vm._v(" "), _c('el-timeline', {
    attrs: {
      "reverse": _vm.reverse
    }
  }, _vm._l((_vm.repayTimeList), function(item, index) {
    return _c('el-timeline-item', {
      key: index,
      attrs: {
        "color": _vm.getrePayColor(item, index)
      }
    }, [_c('div', {
      style: (index === 0 ? {
        color: '#5EA8F8'
      } : {})
    }, [_c('span', [_vm._v(_vm._s(item.time))]), _vm._v(" "), _c('el-tag', {
      staticStyle: {
        "margin-left": "10px"
      },
      attrs: {
        "type": _vm.getreypayTagType(item, index)
      }
    }, [_vm._v("\n                " + _vm._s(item.style) + "\n              ")])], 1), _vm._v(" "), _c('div', {
      staticStyle: {
        "margin-top": "8px",
        "margin-bottom": "20px",
        "font-size": "13px",
        "color": "gray"
      }
    }, [_vm._v("\n              " + _vm._s(item.record) + "\n            ")])])
  }), 1)], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2d9cdfa6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/order/orderRepayment.vue
// module id = 999
// module chunks = 3